import { url } from 'utils/urls';
import axios from "axios";

const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
const withCredentials = true;

export const asyncGetDetailQuestionsAnswered = paramString => axios.post(`${url.ppa.metrics.questionAnswered}/detailed`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetDetailTopQuestionsAnswered = paramString => axios.post(`${url.ppa.metrics.questionAnswered}/top-questions`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetDetailAverageInView = paramString => axios.post(`${url.ppa.metrics.embedLoad}/detailed`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetDetailUniqueEngagedUsers = paramString => axios.post(`${url.ppa.metrics.uniqueEngagedUsers}/detailed`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetDetailRevenueMetrics = paramString => axios.post(`${url.rms.metrics.revenue}/detail`, encodeURI(paramString), { headers, withCredentials });

export const asyncGetDetailTopStoryClicks = paramString => axios.post(`${url.ppa.metrics.storyClicked}/top-stories`, encodeURI(paramString), { headers, withCredentials });
export const asyncGetStories = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/stories`, { withCredentials });
export const asyncGetDetailStoryClicks = paramString => axios.post(`${url.ppa.metrics.storyClicked}/detailed`, encodeURI(paramString), { headers, withCredentials });
export const getSitesCountriesOrEmbeds = paramString => axios.get(`${url.ppa.accounts}${paramString}`, { withCredentials });

export const getSites = (accountUUID, paramString) => axios.get(`${url.ppa.accounts}/${accountUUID}/sites${paramString}`, { withCredentials });
export const getCountries = (accountUUID, paramString) => axios.get(`${url.ppa.accounts}/${accountUUID}/countries${paramString}`, { withCredentials });
export const getEmbeds = accountUUID => axios.get(`${url.ppa.accounts}/${accountUUID}/embeds`, { withCredentials });

export const getAllDetailData = (dataType) =>{
    return getAllDetailDataApiCall(dataType)
};



export const getAllDetailDataApiCall = (dataType) => {
    switch (dataType) {
        case 'questionsanswered':
           return asyncGetDetailQuestionsAnswered;
        case 'topquestionsanswered':
           return asyncGetDetailTopQuestionsAnswered;
        case 'averageinview':
            return asyncGetDetailAverageInView;
        case 'uniqueengagedusers':
           return asyncGetDetailUniqueEngagedUsers;
        case 'cpm':
            return asyncGetDetailRevenueMetrics;
        case 'impression':
            return asyncGetDetailRevenueMetrics;
        case 'revenue':
           return asyncGetDetailRevenueMetrics;
        case 'storyclicked':
            return asyncGetDetailStoryClicks;
        default:
            break;
    }
};
